// assets/scroll-animation.js

// Funktion, die prüft, ob ein Element im Viewport sichtbar ist
function isElementInViewport(el) {
    const rect = el.getBoundingClientRect();
    return (
        rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.bottom >= 0
    );
}

// Funktion, die beim Scrollen oder Laden ausgeführt wird
function checkSpecificHeadingAnimations() {
    // Wähle BEIDE spezifischen Heading-Elemente anhand ihrer Sektions-IDs aus
    // Die IDs aus den von dir bereitgestellten HTML-Blöcken sind hier eingefügt
    const elementsToAnimate = document.querySelectorAll(
        '#shopify-section-template--23660572574025__rich_text_GnLNny .rich-text__heading, ' +
        '#shopify-section-template--23660572574025__rich_text_gEnE3T .rich-text__heading'
    );

    // Durchlaufe alle gefundenen Headings (sollten hier 2 sein)
    elementsToAnimate.forEach(heading => {
        // Überprüfe, ob das Heading existiert und noch nicht animiert wurde
        if (heading && !heading.classList.contains('is-visible')) {
            // Prüfe, ob das Element im Viewport ist
            if (isElementInViewport(heading)) {
                // Wenn sichtbar, füge die Klasse 'is-visible' hinzu
                // Das CSS im Custom CSS Feld dieser Abschnitte wird dadurch aktiv
                heading.classList.add('is-visible');
                // Den Listener nicht entfernen, da das andere Element noch animiert werden muss
            }
        }
    });

    // Optional: Listener entfernen, wenn alle gefundenen Elemente animiert sind
    const allAnimated = Array.from(elementsToAnimate).every(el => el.classList.contains('is-visible'));
    if (allAnimated && elementsToAnimate.length > 0) {
        window.removeEventListener('scroll', checkSpecificHeadingAnimations);
        // console.log('All specified headings animated, scroll listener removed.');
    }
}

// Füge den Event Listener für das Scroll-Ereignis hinzu
window.addEventListener('scroll', checkSpecificHeadingAnimations);

// Führe die Prüfung auch einmal beim Laden der Seite aus
checkSpecificHeadingAnimations();